var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 883,
    height: 458,
    viewBox: "0 0 883 458",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_113070",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 879,
    height: 454
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 879,
    height: 454,
    rx: 4,
    fill: "#E4F3F2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_113070)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M706.205 244.442C847.151 282.208 991.225 201.554 1028 64.295C1064.78 -72.9636 980.337 -214.849 839.391 -252.616C698.445 -290.382 554.371 -209.728 517.592 -72.4693C480.814 64.7893 565.259 206.675 706.205 244.442Z",
    fill: "#4EAEA5",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M706.205 244.442C847.151 282.208 991.225 201.554 1028 64.295C1064.78 -72.9636 980.337 -214.849 839.391 -252.616C698.445 -290.382 554.371 -209.728 517.592 -72.4693C480.814 64.7893 565.259 206.675 706.205 244.442Z",
    fill: "url(#paint0_linear_1_113070)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_113070",
    x1: 839.391,
    y1: -252.616,
    x2: 706.205,
    y2: 244.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundCircle);
export default __webpack_public_path__ + "static/media/BackgroundCircle.8858c4ce.svg";
export { ForwardRef as ReactComponent };